import React, {Fragment} from "react";

import {Box} from "@mui/material";
import {MenuDrawerConsumer} from "@contexts/MenuDrawerProvider";
import FuturApplicationsView from "@views/Dashboard/DashboardFutur/FuturApplicationsView";
import FuturWithdrawalsView from "./FuturWithdrawalsView.jsx";

const DashboardFuturOptions = props => {
	const menuDrawerCtxt = MenuDrawerConsumer();
	const selectedSection = menuDrawerCtxt.state.selectedChild;

	return (
		<Fragment>
			<Box sx={{
				width: "100%",
				display: "flex",
				flexDirection: "row",
				justifyContent: "left",
				marginBottom: 2
			}}>
				{selectedSection === "futur_applications" && (
					<FuturApplicationsView {...props} />
				)}

				{selectedSection === "futur_withdrawals" && (
					<FuturWithdrawalsView {...props} />
				)}
			</Box>
		</Fragment>
	);
};

export default DashboardFuturOptions;
